<!-- El fondo con luz: sin algo detrás que difuminar, el cristal no se
     nota sobre el gris plano del COS. -->
<div class="gia-fondo" aria-hidden="true">
  <span class="gia-luz gia-luz--1"></span>
  <span class="gia-luz gia-luz--2"></span>
  <span class="gia-luz gia-luz--3"></span>
</div>

<!-- Con una solicitud abierta el tablero se ESCONDE, no se destruye: al
     regresar siguen ahí los filtros, la página de cada columna y lo que se
     había arrastrado. Sólo se pierde la posición del scroll, que se guarda
     y se repone a mano (guardaPosicion / reponPosicion). -->
<div class="gia" [class.gia--oculta]="abierta">

  <!-- ==================== Filtros ==================== -->
  <div class="gia-filtros">
    <label class="gia-buscar">
      <span class="material-icons">search</span>
      <input type="text" name="busca" [(ngModel)]="busca" maxlength="60"
             (keyup.enter)="filtra()"
             placeholder="Buscar por folio, nombre de la IA o quien la pidió…">
      <button type="button" class="gia-buscar__x" *ngIf="busca"
              (click)="busca = ''; filtra()" aria-label="Limpiar búsqueda">
        <span class="material-icons">close</span>
      </button>
    </label>

    <label class="gia-sel">
      <span class="gia-sel__et">Responsable</span>
      <select name="fResp" [(ngModel)]="filtroResponsable" (ngModelChange)="filtra()">
        <option [ngValue]="null">Todos</option>
        <option *ngFor="let r of responsables" [ngValue]="r.idUsuarioResponsable">
          {{ r.responsable }}
        </option>
      </select>
    </label>

    <button type="button" class="gia-limpiar" *ngIf="hayFiltro" (click)="limpiaFiltros()">
      <span class="material-icons">filter_alt_off</span>
      Limpiar
    </button>

    <span class="gia-total" *ngIf="!cargando">
      <b>{{ totalItems }}</b> {{ totalItems === 1 ? "solicitud" : "solicitudes" }}
    </span>

    <!-- Ya no hay encabezado (pedido de Norman, 17/09/2026): el indicador
         vive al final de la fila de filtros. Tampoco hay boton de
         Actualizar: el tablero se refresca solo.
         Lo que queda es decir que esta vivo, porque un tablero que
         cambia sin que nadie lo toque, sin avisar, desconcierta. -->
    <span class="gia-vivo"
          [class.es-caido]="sinConexion || sinPermiso || sesionCaida || !latidoVivo"
          [matTooltip]="sesionCaida
            ? 'La sesión del servidor caducó. Se dejó de consultar: vuelve a entrar.'
            : (sinPermiso
                ? 'El servidor contestó que ya no tienes permiso para atender solicitudes. Se dejó de consultar.'
                : (!latidoVivo
                    ? 'Se dejó de consultar. Vuelve a entrar.'
                    : (sinConexion
                        ? 'No se pudo consultar la última vez. Se vuelve a intentar solo.'
                        : 'El tablero se actualiza solo cada pocos segundos')))">
      <span class="gia-vivo__punto" aria-hidden="true"></span>
      {{ sesionCaida
          ? "Sesión caducada"
          : (sinPermiso
              ? "Sin permiso"
              : (!latidoVivo ? "Detenido" : (sinConexion ? "Sin conexión" : "En vivo"))) }}
    </span>
  </div>

  <div class="gia-error" *ngIf="error">
    <span class="material-icons">error_outline</span> {{ error }}
  </div>

  <div class="gia-cargando" *ngIf="cargando">
    <span class="material-icons">hourglass_top</span> Consultando…
  </div>

  <!-- ==================== El tablero ====================
       Cinco columnas fijas. Cada una se desliza por dentro si le sobran
       tarjetas, para que el tablero completo siempre quepa de un vistazo. -->
  <!-- cdkDropListGroup conecta las cinco columnas entre sí: una tarjeta se
       arrastra de una a otra. El hueco sólo aparece en las columnas que
       aceptan ESA tarjeta (puedeRecibir), y soltar abre el mismo diálogo
       que el botón de esa etapa. -->
  <div class="gia-tablero" #tablero *ngIf="!cargando" cdkDropListGroup cdkScrollable>
    <section class="gia-col" *ngFor="let c of columnas; let i = index; trackBy: trackColumna"
             [style.--col]="c.color">
      <!-- Cada columna es una ETAPA, y se lee como tal: número de paso,
           nombre y en cuatro palabras qué significa estar ahí. -->
      <header class="gia-col__cab">
        <span class="gia-col__paso" aria-hidden="true">{{ i + 1 }}</span>
        <span class="material-icons">{{ c.icono }}</span>
        <span class="gia-col__tit">
          <h4>{{ c.titulo }}</h4>
          <small>{{ c.pista }}</small>
        </span>
        <span class="gia-col__n">{{ c.solicitudes.length }}</span>
      </header>

      <!-- Sin reordenar dentro de la columna (el orden lo pone el servidor):
           el hueco se queda donde estaba la tarjeta y la columna de destino
           se ilumina al pasar por encima. -->
      <div class="gia-col__cuerpo"
           cdkDropList
           [cdkDropListData]="c"
           [cdkDropListSortingDisabled]="true"
           [cdkDropListEnterPredicate]="puedeRecibir"
           (cdkDropListDropped)="soltar($event)">
        <p class="gia-col__vacia" *ngIf="!c.solicitudes.length">
          <span class="material-icons" aria-hidden="true">{{ c.icono }}</span>
          {{ c.vacia }}
        </p>

        <!-- Se arrastra la que atiendo yo, o una libre (llevarla a Proceso es
             tomarla). En táctil el dedo espera un cuarto de segundo antes de
             levantar la tarjeta, para que deslizar la columna siga siendo
             deslizar. -->
        <!-- data-sol: al regresar del detalle, el foco vuelve a esta
             tarjeta (reponPosicion). -->
        <button type="button" class="gia-card"
                *ngFor="let s of pagina(c); trackBy: trackSolicitud"
                [attr.data-sol]="s.idSolicitudIa"
                [attr.data-cierre]="cierreDe(s)"
                [class.es-abierta]="abierta && abierta.idSolicitudIa === s.idSolicitudIa"
                [class.es-arrastrable]="puedeArrastrar(s)"
                cdkDrag
                [cdkDragData]="s"
                [cdkDragDisabled]="!puedeArrastrar(s)"
                [cdkDragStartDelay]="{ touch: 250, mouse: 0 }"
                (cdkDragStarted)="alEmpezarArrastre()"
                (cdkDragEnded)="alSoltarArrastre()"
                (click)="abre(s)">
          <span class="gia-card__alto">
            <span class="gia-folio">{{ s.folio }}</span>
            <!-- En Cerradas conviven dos finales distintos: la que NO se
                 autorizó (roja) y la que retiró quien la pidió (gris). La
                 etiqueta lo dice en palabras; el color, de un vistazo. -->
            <span class="gia-card__cierre" *ngIf="cierreDe(s)" [attr.data-cierre]="cierreDe(s)">
              <span class="material-icons" aria-hidden="true">{{ cierreDe(s) === "no" ? "block" : "undo" }}</span>
              {{ cierreDe(s) === "no" ? "No autorizada" : "Retirada" }}
            </span>
            <span class="gia-card__arch" *ngIf="s.archivos" matTooltip="Archivos adjuntos">
              <span class="material-icons">attach_file</span>{{ s.archivos }}
            </span>
            <span class="gia-card__fecha" *ngIf="s.fechaSolicitud"
                  [matTooltip]="s.fechaSolicitud">{{ fechaCorta(s.fechaSolicitud) }}</span>
          </span>

          <span class="gia-card__nombre">{{ s.nombreIa }}</span>

          <span class="gia-card__quien">
            <span class="gia-card__ini">{{ iniciales(s.solicitante) }}</span>
            <span class="gia-card__nom" [matTooltip]="s.solicitante || ''">
              {{ s.solicitante }}
            </span>
          </span>

          <span class="gia-card__pie">
            <span class="gia-card__area" *ngIf="s.area" [matTooltip]="s.area">{{ s.area }}</span>
            <span class="gia-card__resp" [class.es-libre]="!s.idUsuarioResponsable"
                  [class.es-mia]="esMia(s)"
                  [matTooltip]="esMia(s) ? 'La atiendes tú' : (s.responsable || 'Todavía nadie la atiende')">
              <span class="material-icons">
                {{ s.idUsuarioResponsable ? (esMia(s) ? "how_to_reg" : "person") : "person_off" }}
              </span>
              <!-- La mía dice «Tú»: es más corto que el nombre y es lo que
                   importa saber de un vistazo. Las demás llevan el nombre,
                   con puntos suspensivos si no cabe. -->
              <span class="gia-card__resp-nom">
                {{ esMia(s) ? "Tú" : (s.responsable || "Sin asignar") }}
              </span>
            </span>
          </span>

          <!-- Lo que vuela con el mouse. Es una copia compacta de la
               tarjeta con sus colores escritos (el CDK la cuelga del
               body, fuera del componente: ahí las variables no llegan). -->
          <div *cdkDragPreview [matchSize]="true" class="gia-card gia-card--vuela" [style.--col]="c.color">
            <span class="gia-card__alto">
              <span class="gia-folio">{{ s.folio }}</span>
              <span class="gia-card__fecha" *ngIf="s.fechaSolicitud">{{ fechaCorta(s.fechaSolicitud) }}</span>
            </span>
            <span class="gia-card__nombre">{{ s.nombreIa }}</span>
            <!-- Los mismos cuatro renglones de la tarjeta: con matchSize la
                 copia mide lo que la original, y con menos renglones dejaba
                 una franja vacía abajo. -->
            <span class="gia-card__quien">
              <span class="gia-card__ini">{{ iniciales(s.solicitante) }}</span>
              <span class="gia-card__nom">{{ s.solicitante }}</span>
            </span>
            <span class="gia-card__pie">
              <span class="gia-card__area" *ngIf="s.area">{{ s.area }}</span>
              <span class="gia-card__resp" [class.es-libre]="!s.idUsuarioResponsable"
                    [class.es-mia]="esMia(s)">
                <span class="material-icons">
                  {{ s.idUsuarioResponsable ? (esMia(s) ? "how_to_reg" : "person") : "person_off" }}
                </span>
                <span class="gia-card__resp-nom">
                  {{ esMia(s) ? "Tú" : (s.responsable || "Sin asignar") }}
                </span>
              </span>
            </span>
          </div>
        </button>
      </div>

      <!-- El paginador va FUERA del cuerpo que se desliza: dentro, se iba
           con el scroll y quedaba escondido justo cuando hacía falta.
           Sólo aparece pasando de cinco: con tres tarjetas es ruido. -->
      <div class="gia-col__pager" *ngIf="paginas(c) > 1">
        <button type="button" (click)="pasaPagina(c, -1)" [disabled]="c.pagina <= 1"
                aria-label="Anteriores">
          <span class="material-icons">chevron_left</span>
        </button>
        <span>{{ rango(c) }}</span>
        <button type="button" (click)="pasaPagina(c, 1)" [disabled]="c.pagina >= paginas(c)"
                aria-label="Siguientes">
          <span class="material-icons">chevron_right</span>
        </button>
      </div>
    </section>
  </div>
</div>

<!-- ==================== El detalle, en su propia pantalla ====================
     Antes era un modal encima del tablero; ahora ocupa la pantalla entera,
     con Regresar arriba a la izquierda (pedido de Norman, 23/09/2026: «que
     se vea mejor»). Por dentro es lo mismo que era el modal —las dos
     mitades lado a lado, las acciones fijas abajo—, sólo que con todo el
     ancho y todo el alto.
     La solicitud va en la dirección (?solicitud=42): el Atrás del navegador
     regresa al tablero, recargar deja la misma solicitud abierta y el
     enlace se puede pasar a otro de los cinco. -->
<section class="gia-detalle" *ngIf="abierta" aria-labelledby="giaDetalleTitulo"
         [style.--est]="colorEstatus(abierta)">
  <div class="gia-detalle__caja">

    <!-- El filo de color: dice el estatus antes de leer una sola letra. -->
    <span class="gia-detalle__filo" aria-hidden="true"></span>

    <!-- ---------- Cabecera ----------
         De izquierda a derecha: Regresar; la solicitud —el título primero,
         que es lo que se lee, y debajo folio y estatus—; y en el espacio que
         sobraba a la derecha, las cinco etapas (pedido de Norman, 23/09/2026:
         «usa el espacio que está al lado… y que sirva lo de mover etapas»). -->
    <!-- Tres partes en una rejilla (pedido de Norman, 23/09/2026): la
         solicitud a la izquierda —icono, título y debajo folio y estatus—,
         las etapas centradas en medio y Regresar a la derecha. Si la caja
         no da para las tres en un renglón, las etapas bajan al segundo
         (@container gia-detalle en el CSS). -->
    <header class="gia-detalle__cab">
      <div class="gia-detalle__quien">
        <span class="gia-detalle__ico">
          <span class="material-icons">{{ iconoEstatus(abierta) }}</span>
        </span>

        <div class="gia-detalle__txt">
          <!-- tabindex -1: al abrir, el foco llega aquí y el lector de
               pantalla anuncia qué solicitud se abrió. -->
          <h1 id="giaDetalleTitulo" tabindex="-1" #detalleTitulo>{{ abierta.nombreIa || "Abriendo la solicitud…" }}</h1>
          <div class="gia-detalle__alto">
            <span class="gia-folio" *ngIf="abierta.folio">{{ abierta.folio }}</span>
            <span class="gia-estatus" *ngIf="abierta.estatus" [ngClass]="clase(abierta)">{{ etiqueta(abierta) }}</span>
            <span class="gia-chip es-alerta" *ngIf="abierta.datosSensibles === 'SI'"
                  matTooltip="Va a tratar datos de la empresa o personales">
              <span class="material-icons">gpp_maybe</span> Datos sensibles
            </span>
          </div>
        </div>
      </div>

      <!-- Las etapas: las mismas cinco columnas del tablero, con su número y
           su color. Picar una mueve la solicitud ahí, con las mismas reglas
           y los mismos diálogos que arrastrar la tarjeta (puedeIrA / moverA).
           Las que no se pueden quedan con aria-disabled y no con disabled,
           para que su globo siga diciendo por qué. Debajo, en palabras, qué
           se puede hacer o por qué no (notaEtapas). -->
      <nav class="gia-etapas" *ngIf="abierta.estatus" aria-label="Etapa de la solicitud">
        <ol class="gia-etapas__lista">
          <li *ngFor="let c of columnas; let i = index; trackBy: trackColumna">
            <button type="button" class="gia-etapa"
                    [style.--col]="c.color"
                    [class.es-actual]="esEtapaActual(c)"
                    [class.es-destino]="puedeIrA(c)"
                    [attr.aria-current]="esEtapaActual(c) ? 'step' : null"
                    [attr.aria-disabled]="!puedeIrA(c) || trabajando ? 'true' : null"
                    [matTooltip]="queHaceEtapa(c)"
                    (click)="moverA(c)">
              <span class="gia-etapa__n" aria-hidden="true">{{ i + 1 }}</span>
              <span class="material-icons" aria-hidden="true">{{ c.icono }}</span>
              <span class="gia-etapa__t">{{ c.titulo }}</span>
            </button>
          </li>
        </ol>
        <p class="gia-etapas__nota">
          <span class="material-icons" aria-hidden="true">{{ puedeMoverla ? "touch_app" : "lock_person" }}</span>
          {{ notaEtapas }}
        </p>
      </nav>

      <!-- El botón global de regresar del admin (el mismo del detalle de
           Inventario IA), no uno propio. -->
      <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact gia-regresar"
              (click)="regresar()" matTooltip="Regresar al tablero (Esc)">
        <span class="material-icons" aria-hidden="true">arrow_back</span> Regresar
      </button>
    </header>

    <div class="gia-cargando" *ngIf="cargandoDetalle">
      <span class="material-icons">hourglass_top</span> Abriendo…
    </div>

    <!-- ---------- Cuerpo, en dos mitades ---------- -->
    <div class="gia-detalle__cuerpo" *ngIf="!cargandoDetalle">

      <!-- ===== Izquierda: la solicitud ===== -->
      <div class="gia-detalle__izq">

        <!-- Lo que se mira primero, en cuatro fichas. -->
        <div class="gia-fichas">
          <div class="gia-ficha">
            <span class="gia-ficha__et">
              <span class="material-icons">person</span> Quien la pide
            </span>
            <span class="gia-ficha__val">
              <span class="gia-ficha__ini">{{ iniciales(abierta.solicitante) }}</span>
              <span class="gia-ficha__nom">{{ abierta.solicitante }}</span>
            </span>
            <a class="gia-ficha__extra" *ngIf="abierta.telefonoContacto"
               [href]="'tel:' + abierta.telefonoContacto">
              <span class="material-icons">call</span>{{ abierta.telefonoContacto }}
            </a>
          </div>

          <div class="gia-ficha">
            <span class="gia-ficha__et">
              <span class="material-icons">apartment</span> Área
            </span>
            <span class="gia-ficha__val">{{ abierta.area || "—" }}</span>
          </div>

          <div class="gia-ficha" [class.es-libre]="!abierta.idUsuarioResponsable">
            <span class="gia-ficha__et">
              <span class="material-icons">
                {{ abierta.idUsuarioResponsable ? "assignment_ind" : "person_off" }}
              </span> Responsable
            </span>
            <span class="gia-ficha__val">{{ abierta.responsable || "Sin asignar" }}</span>
          </div>

          <div class="gia-ficha">
            <span class="gia-ficha__et">
              <span class="material-icons">event</span> Solicitada
            </span>
            <span class="gia-ficha__val">{{ abierta.fechaSolicitud || "—" }}</span>
            <span class="gia-ficha__extra" *ngIf="abierta.fechaRequerida">
              <span class="material-icons">flag</span>La necesita para
              {{ abierta.fechaRequerida }}
            </span>
          </div>
        </div>

        <!-- El link, que es lo que mas se pulsa. -->
        <a class="gia-enlace" *ngIf="abierta.urlIa" [href]="abierta.urlIa"
           target="_blank" rel="noopener noreferrer">
          <span class="material-icons">travel_explore</span>
          <span class="gia-enlace__txt">
            <b>Abrir la IA</b>
            <span>{{ abierta.urlIa }}</span>
          </span>
          <span class="material-icons gia-enlace__ir">open_in_new</span>
        </a>

        <section class="gia-bloque">
          <h5><span class="material-icons">flag</span> Propósito</h5>
          <p class="gia-largo">{{ abierta.proposito }}</p>
        </section>

        <section class="gia-bloque">
          <h5><span class="material-icons">construction</span> Uso previsto</h5>
          <p class="gia-largo">{{ abierta.usoPrevisto }}</p>
        </section>

        <section class="gia-bloque" *ngIf="abierta.proveedor">
          <h5><span class="material-icons">store</span> Proveedor</h5>
          <p>{{ abierta.proveedor }}</p>
        </section>

        <!-- ===== Archivo DAR =====
             UN solo apartado. El DAR puede venir de dos formas —el Excel
             subido o el formato capturado en pantalla— y antes cada una
             traia su propio titulo "Archivo DAR", asi que el mismo
             encabezado salia dos veces seguidas. -->
        <section class="gia-bloque" *ngIf="estadoDar === 'hay'">
          <h5><span class="material-icons">fact_check</span> Archivo DAR</h5>

          <!-- Se pinta lo que SI llego, y encima el aviso de lo que no.
               Antes, con un solo adjunto el aviso desaparecia y el
               evaluador dictaminaba creyendo que eso era todo. -->
          <div class="gia-nada gia-nada--falla" *ngIf="falloAlgoDelDar">
            <span class="material-icons">error_outline</span>
            <span>
              Falta por consultar parte del expediente
              <b>y no se pudo</b>: lo que ves abajo puede no ser todo.
            </span>
            <button type="button" class="gia-mini" (click)="reintentaDar()">
              <span class="material-icons" aria-hidden="true">refresh</span> Reintentar
            </button>
          </div>

          <button type="button" class="gia-dar" *ngIf="dar" (click)="abreDar()">
            <span class="material-icons">assignment</span>
            <span class="gia-dar__txt">
              <b>DAR capturado en pantalla</b>
              <span>FOR-012 · {{ dar.proyectoArea || "sin proyecto" }}</span>
            </span>
            <span class="material-icons gia-dar__ir">chevron_right</span>
          </button>

          <div class="gia-archivo" *ngFor="let a of archivos">
            <span class="material-icons">
              {{ esExcel(a) ? "table_view" : "description" }}
            </span>
            <span class="gia-archivo__nom" [matTooltip]="a.nombreArchivo || ''">
              {{ a.nombreArchivo }}
            </span>
            <button type="button" class="gia-ico" (click)="descarga(a)"
                    matTooltip="Descargar"
                    [attr.aria-label]="'Descargar ' + (a.nombreArchivo || 'el archivo')">
              <span class="material-icons" aria-hidden="true">download</span>
            </button>
          </div>
        </section>

        <!-- Tres cosas distintas, y antes las tres decían lo mismo:
             todavía se está preguntando, no se pudo preguntar, y de
             verdad no hay DAR. La del medio es la que importa: sobre
             ella se decide si la solicitud va sin justificación. -->
        <section class="gia-bloque" *ngIf="estadoDar !== 'hay'">
          <h5><span class="material-icons">fact_check</span> Archivo DAR</h5>

          <p class="gia-nada" *ngIf="estadoDar === 'cargando'">
            <span class="material-icons">hourglass_top</span>
            Buscando el DAR…
          </p>

          <div class="gia-nada gia-nada--falla" *ngIf="estadoDar === 'falla'">
            <span class="material-icons">error_outline</span>
            <span>
              No se pudo consultar el DAR. <b>No quiere decir que no lo haya:</b>
              vuelve a intentarlo antes de dictaminar.
            </span>
            <button type="button" class="gia-mini" (click)="reintentaDar()">
              <span class="material-icons" aria-hidden="true">refresh</span> Reintentar
            </button>
          </div>

          <p class="gia-nada" *ngIf="estadoDar === 'vacio'">
            <span class="material-icons">info_outline</span>
            No adjuntó el DAR ni lo llenó en pantalla.
          </p>
        </section>

        <!-- ===== Evidencia de la evaluación =====
             Entre lo que trajo quien pidió (el DAR, arriba) y la conclusión
             (el dictamen, abajo): se lee en orden. La sube sólo quien la
             atiende, antes de dictaminar; la ven quien la pidió y los cinco. -->
        <section class="gia-bloque gia-evid">
          <h5>
            <span class="material-icons">task</span> Evidencia de la evaluación
            <span class="gia-der__n" *ngIf="evidenciasEval.length">{{ evidenciasEval.length }}</span>
          </h5>

          <p class="gia-evid__ayuda" *ngIf="puedeSubirEvidencia">
            Sube lo que revisaste para evaluarla: pruebas, capturas, reportes. La ve
            quien la pidió. Súbela antes de autorizar o no autorizar: después queda cerrada.
          </p>

          <p class="gia-nada" *ngIf="evidenciaCarga === 'cargando' && !evidenciasEval.length">
            <span class="material-icons">hourglass_top</span> Buscando la evidencia…
          </p>

          <!-- Aquí sólo se dice si hay evidencia o no (pedido de Norman,
               23/09/2026: «que no diga eso»). El único aviso de falla que
               queda es cuando el servidor ya contó archivos (evidenciasEval)
               y la lista no llegó: ahí decir «no hay» sería falso. -->
          <div class="gia-nada gia-nada--falla"
               *ngIf="evidenciaCarga === 'falla' && (abierta.evidenciasEval || 0) > 0">
            <span class="material-icons">error_outline</span>
            <span>Tiene {{ abierta.evidenciasEval }} {{ abierta.evidenciasEval === 1 ? "archivo" : "archivos" }} de evidencia, pero no se pudieron cargar.</span>
            <button type="button" class="gia-mini" (click)="reintentaEvidencia()">
              <span class="material-icons" aria-hidden="true">refresh</span> Reintentar
            </button>
          </div>

          <p class="gia-nada"
             *ngIf="!evidenciasEval.length && !puedeSubirEvidencia
                    && (evidenciaCarga === 'listo' || (evidenciaCarga === 'falla' && !((abierta.evidenciasEval || 0) > 0)))">
            <span class="material-icons">info_outline</span>
            {{ abiertaAun(abierta) ? "Todavía no hay evidencia de la evaluación." : "No se subió evidencia de la evaluación." }}
          </p>

          <div class="gia-archivo gia-evid__archivo" *ngFor="let e of evidenciasEval">
            <span class="material-icons">{{ iconoArchivo(e) }}</span>
            <span class="gia-evid__txt">
              <span class="gia-archivo__nom" [matTooltip]="e.nombreArchivo || ''">{{ e.nombreArchivo }}</span>
              <span class="gia-evid__meta">
                {{ e.usuarioNombre }}<ng-container *ngIf="e.fechaCarga"> · {{ e.fechaCarga }}</ng-container><ng-container *ngIf="e.tamanioBytes != null"> · {{ tamanoLegible(e.tamanioBytes) }}</ng-container>
              </span>
            </span>
            <button type="button" class="gia-mini" *ngIf="seVeEnElNavegador(e)" (click)="verEvidencia(e)">
              <span class="material-icons" aria-hidden="true">open_in_new</span> Ver
            </button>
            <button type="button" class="gia-ico" (click)="descarga(e)" matTooltip="Descargar"
                    [attr.aria-label]="'Descargar ' + (e.nombreArchivo || 'el archivo')">
              <span class="material-icons" aria-hidden="true">download</span>
            </button>
            <button type="button" class="gia-ico gia-ico--quitar" *ngIf="puedeSubirEvidencia"
                    (click)="quitaEvidencia(e)" matTooltip="Quitar"
                    [attr.aria-label]="'Quitar ' + (e.nombreArchivo || 'el archivo')">
              <span class="material-icons" aria-hidden="true">delete_outline</span>
            </button>
          </div>

          <!-- Un label con el input escondido: el clic en cualquier parte
               abre el selector, y con el teclado se llega por el input. -->
          <label class="gia-evid__subir" *ngIf="puedeSubirEvidencia" [class.es-ocupado]="subiendoEvidencia">
            <input type="file" multiple class="gia-evid__input" [attr.accept]="EVIDENCIA_EXT"
                   [disabled]="subiendoEvidencia" (change)="subeEvidencia($event)"
                   aria-label="Subir evidencia de la evaluación">
            <span class="material-icons" aria-hidden="true">{{ subiendoEvidencia ? "hourglass_top" : "upload_file" }}</span>
            <span>
              <b>{{ subiendoEvidencia ? "Subiendo…" : "Subir evidencia" }}</b>
              <small>PDF, Excel, Word, imágenes… hasta 10 MB cada uno</small>
            </span>
          </label>
        </section>

        <!-- El dictamen, cuando ya lo hay -->
        <div class="gia-dictamen" *ngIf="abierta.dictamenMotivo"
             [class.es-no]="abierta.estatus === 'RECHAZADA'">
          <span class="gia-dictamen__cab">
            <span class="material-icons">
              {{ abierta.estatus === "APROBADA" ? "verified" : "block" }}
            </span>
            <b>{{ abierta.estatus === "APROBADA" ? "Autorizada" : "No autorizada" }}</b>
            por {{ abierta.dictaminador }}
          </span>
          <p>{{ abierta.dictamenMotivo }}</p>
          <!-- Un solo renglón de texto junto al icono: con la matriz ya son
               dos folios, y como piezas sueltas del flex no se partían en
               renglones al angostarse el panel. El activo de la matriz no
               lleva enlace: su expediente no tiene ruta propia, sólo se
               abre desde la tarjeta dentro de la matriz. Con el control de
               cambios de la matriz encendido la IA no entra directa: queda
               propuesta, y mientras no se apruebe allá no hay ACT. Si la
               descartan, se dice, pero nunca que está en la matriz. -->
          <div *ngIf="abierta.inventarioFolio" class="gia-inv">
            <span class="material-icons" aria-hidden="true">inventory_2</span>
            <span>
              En el inventario como <b>{{ abierta.inventarioFolio }}</b><ng-container
                *ngIf="abierta.matrizFolio"> y en la Matriz de Riesgos IA como
                <b>{{ abierta.matrizFolio }}</b></ng-container><ng-container
                *ngIf="!abierta.matrizFolio && abierta.matrizPropuesta === 'PENDIENTE'"> y
                propuesta a la Matriz de Riesgos IA, <b>pendiente de aprobar</b></ng-container><ng-container
                *ngIf="!abierta.matrizFolio && abierta.matrizPropuesta === 'DESCARTADO'"> · su
                propuesta a la Matriz de Riesgos IA se descartó</ng-container><ng-container
                *ngIf="abierta.catArea"> · área ISO: {{ abierta.catArea }}</ng-container>
            </span>
          </div>
        </div>
      </div>

      <!-- ===== Derecha: lo que ha pasado ===== -->
      <div class="gia-detalle__der">
        <h5 class="gia-der__tit">
          <span class="material-icons">history</span> Historia
          <span class="gia-der__n">{{ historial.length }}</span>
        </h5>

        <!-- La historia se desliza por dentro (pedido de Norman, 22/09/2026):
             antes crecía hasta meterse debajo de la caja de comentar. El
             título y esa caja se quedan fijos; sólo rueda la lista, y se abre
             hasta abajo, que es donde está lo último que pasó. -->
        <div class="gia-linea" #historiaCaja>
          <p class="gia-nada" *ngIf="!historial.length">
            <span class="material-icons">info_outline</span> Todavía no pasa nada.
          </p>
          <!-- La raya vertical va en este hilo y no en la caja que se
               desliza: así mide lo que miden los renglones y rueda con ellos. -->
          <div class="gia-linea__hilo" *ngIf="historial.length">
            <!-- Cada movimiento con el color de su etapa (claseHistorial), y
                 los comentarios en globo: quién y cuándo arriba, lo que dijo
                 adentro. Así la conversación se distingue de lo que hizo el
                 sistema. -->
            <div class="gia-hist" *ngFor="let h of historial; trackBy: trackHistorial"
                 [ngClass]="claseHistorial(h)">
              <span class="gia-hist__ico" aria-hidden="true">
                <span class="material-icons">{{ iconoHistorial(h) }}</span>
              </span>
              <div class="gia-hist__txt" *ngIf="h.accion === 'COMENTARIO'; else movimiento">
                <div class="gia-hist__globo">
                  <span class="gia-hist__quien"><b>{{ h.usuario }}</b><span>{{ h.fecha }}</span></span>
                  <p>{{ h.comentario }}</p>
                </div>
              </div>
              <ng-template #movimiento>
                <div class="gia-hist__txt">
                  <b>{{ textoHistorial(h) }}</b>
                  <p *ngIf="notaHistorial(h)">{{ notaHistorial(h) }}</p>
                  <span class="gia-hist__pie">{{ h.usuario }} · {{ h.fecha }}</span>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <!-- La caja de comentar, de una pieza: el texto, los archivos
             adjuntos, el clip, la ayuda del teclado y el botón dentro del
             mismo marco, con su aro al escribir. -->
        <div class="gia-comentar" *ngIf="abiertaAun(abierta)">
          <div class="gia-comentar__marco">
            <textarea rows="2" maxlength="2000" [(ngModel)]="comentario"
                      name="comentario" aria-label="Comentario"
                      placeholder="Escribe un comentario…"
                      (keydown.control.enter)="comentaConTeclado($event)"
                      (keydown.meta.enter)="comentaConTeclado($event)"></textarea>
            <!-- Lo que se va a subir con el comentario, con su equis. -->
            <ul class="gia-adjuntos" *ngIf="adjuntos.length" aria-label="Archivos que se van a subir">
              <li class="gia-adjunto" *ngFor="let f of adjuntos; let i = index">
                <span class="material-icons" aria-hidden="true">attach_file</span>
                <span class="gia-adjunto__nom" [matTooltip]="f.name">{{ f.name }}</span>
                <span class="gia-adjunto__tam">{{ tamanoLegible(f.size) }}</span>
                <button type="button" class="gia-adjunto__x" (click)="quitaAdjunto(i)"
                        [disabled]="subiendoEvidencia" [attr.aria-label]="'No subir ' + f.name">
                  <span class="material-icons" aria-hidden="true">close</span>
                </button>
              </li>
            </ul>
            <div class="gia-comentar__pie">
              <!-- El clip: sólo quien atiende la solicitud sube evidencia. -->
              <label class="gia-comentar__clip" *ngIf="puedeSubirEvidencia"
                     [class.es-ocupado]="subiendoEvidencia"
                     matTooltip="Adjuntar evidencia de la evaluación">
                <input type="file" multiple class="gia-evid__input" [attr.accept]="EVIDENCIA_EXT"
                       [disabled]="subiendoEvidencia" (change)="agregaAdjuntos($event)"
                       aria-label="Adjuntar evidencia de la evaluación">
                <span class="material-icons" aria-hidden="true">attach_file</span>
              </label>
              <!-- Sin contador (pedido de Norman, 23/09/2026): el tope de 2000
                   lo sigue poniendo maxlength. -->
              <span class="gia-comentar__ayuda">
                {{ adjuntos.length ? "Se guardan como evidencia de la evaluación" : "Ctrl + Enter para enviar" }}
              </span>
              <button type="button" class="gia-btn gia-btn--primario gia-btn--chico"
                      [disabled]="(!comentario.trim() && !adjuntos.length) || trabajando || subiendoEvidencia"
                      (click)="comenta()">
                <span class="material-icons">{{ subiendoEvidencia ? "hourglass_top" : "send" }}</span>
                {{ subiendoEvidencia ? "Subiendo…" : (adjuntos.length && !comentario.trim() ? "Subir" : "Enviar") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ---------- Las acciones, fijas abajo ---------- -->
    <!-- Tres casos y cada uno ve lo suyo: sin dueño, sólo "Tomarla" (y al
         tomarla pasa sola a Proceso); si la atiende otro, se dice quién y
         no hay botones; si es mía, las etapas. El servidor aplica la misma
         regla, así que esto es para no ofrecer lo que va a fallar. -->
    <!-- Sólo cuando hay algo que picar. Si no —la pediste tú, la atiende
         otro—, el porqué ya lo dice la nota de las etapas, arriba, y un pie
         con un solo aviso era una franja vacía. -->
    <footer class="gia-detalle__pie" *ngIf="!cargandoDetalle && abiertaAun(abierta) && hayAcciones(abierta)">
      <ng-container *ngIf="!abierta.idUsuarioResponsable && !esMiSolicitud(abierta)">
        <span class="gia-pie__nota">
          <span class="material-icons">info_outline</span>
          Al tomarla pasa a Proceso, y sólo quien la toma la mueve de etapa.
        </span>
        <span class="gia-aire"></span>
        <button type="button" class="gia-btn gia-btn--primario" (click)="tomar()"
                [disabled]="trabajando">
          <span class="material-icons">pan_tool</span> Tomarla
        </button>
      </ng-container>

      <ng-container *ngIf="esMia(abierta)">
        <span class="gia-pie__nota es-mia">
          <span class="material-icons">how_to_reg</span> La atiendes tú
        </span>
        <button type="button" class="gia-btn" (click)="evaluar()"
                [disabled]="trabajando" *ngIf="abierta.estatus !== 'EN_EVALUACION'">
          <span class="material-icons">play_arrow</span> Volver a proceso
        </button>
        <button type="button" class="gia-btn" (click)="pedirInfo()"
                [disabled]="trabajando" *ngIf="abierta.estatus !== 'INFORMACION_REQUERIDA'">
          <span class="material-icons">help_outline</span> Pedir información
        </button>
        <span class="gia-aire"></span>
        <!-- Nadie dictamina lo suyo (VAL-004): con datos viejos puede pasar
             que sea mía y además la haya pedido yo. -->
        <span class="gia-pie__nota" *ngIf="esMiSolicitud(abierta)">
          <span class="material-icons">lock_person</span>
          La pediste tú: el dictamen lo da otro de los cinco.
        </span>
        <button type="button" class="gia-btn gia-btn--no" (click)="rechazar()"
                [disabled]="trabajando || subiendoEvidencia" *ngIf="!esMiSolicitud(abierta)">
          <span class="material-icons">close</span> No autorizar
        </button>
        <button type="button" class="gia-btn gia-btn--si" (click)="aprobar()"
                [disabled]="trabajando || subiendoEvidencia"
                *ngIf="abierta.estatus === 'EN_EVALUACION' && !esMiSolicitud(abierta)">
          <span class="material-icons">check</span> Autorizar
        </button>
      </ng-container>
    </footer>
  </div>
</section>

<!-- El DAR capturado, en SOLO LECTURA: el evaluador lo consulta, no lo
     reescribe. -->
<app-modal-dar
  *ngIf="darAbierto && dar"
  [dar]="dar"
  [soloLectura]="true"
  (cerrar)="cierraDar()"
></app-modal-dar>

<!-- ==================== Avisos de solicitud nueva ====================
     Arriba a la derecha, encima de todo. Duran dos minutos, se pueden
     cerrar antes, y se van solos en cuanto alguien toma la solicitud:
     un aviso de algo que ya se esta atendiendo no solo es ruido, hace
     que dos personas vayan por lo mismo.

     El contenedor no intercepta el clic —pointer-events: none—, solo
     las tarjetas: si no, taparia media pantalla del tablero. -->
<div class="gia-avisos" *ngIf="avisos.length" aria-live="polite"
     [class.gia-avisos--bajo]="abierta">
  <div class="gia-aviso" *ngFor="let a of avisos; trackBy: trackAviso"
       role="status">
    <span class="gia-aviso__ico">
      <span class="material-icons">notifications_active</span>
    </span>

    <button type="button" class="gia-aviso__txt" (click)="abreDesdeAviso(a)"
            matTooltip="Abrir la solicitud">
      <span class="gia-aviso__tit">Nueva solicitud de IA</span>
      <span class="gia-aviso__que">
        <span class="gia-folio">{{ a.folio }}</span>
        <b>{{ a.nombreIa }}</b>
      </span>
      <span class="gia-aviso__quien" *ngIf="a.solicitante">
        La pidió {{ a.solicitante }}
      </span>
      <span class="gia-aviso__ir">
        <span class="material-icons">arrow_forward</span> Verla
      </span>
    </button>

    <button type="button" class="gia-aviso__x" (click)="cierraAviso(a)"
            aria-label="Cerrar el aviso" matTooltip="Cerrar">
      <span class="material-icons">close</span>
    </button>
  </div>
</div>
